import React from "react"
import Redirect from "../components/redirect"

export default () => (
  <Redirect url="/apps/karatekapp" />
)
